module.exports = __webpack_public_path__ + "img/hr-electric-mining-drill-S.a00679be.png";